import React from 'react'

const Footer = () => {
    return (
        <div className="footer-div">
            <footer>
                Made with &#10084; by <a href="https://rahulbakshi.netlify.app">Rahul Bakshi</a>
            </footer>
        </div>
    )
}

export default Footer
